import * as React from "react"

import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';

import { DialogContent, DialogContentText } from "@material-ui/core";
import axios from "axios";
import CONFIG from "../../cfg/config";

//PM 2021-10-18
interface NotifierProps {
  open: boolean,
  pay_web: string,
  kwota: string,
  vsc_ident: number,
  ws_sukces: string,
  ws_porazka: string,
  onPrzelewy24Success?: () => Promise<void>,
  onPrzelewy24Failure?: () => Promise<void>,
}

//PM 2021-10-15
interface NotifierState {
  openInfo: boolean,
  openTakNie: boolean,
}

class Notifier extends React.Component<NotifierProps, NotifierState> {

  //PM 2021-10-15
  constructor(props: NotifierProps) {
    super(props, {});

    this.state = {
      openInfo: true,
      openTakNie: false,
    };
  }

  //PM 2021-10-15
  getPlatnosc = () => {
    switch (this.props.pay_web) {
      case '1': return 'CashBill'
      case '3': return 'CashBill'
      case '4': return 'Przelewy24'
      case '5': return 'TPay'
      default: return ''
    }
  }

  //PM 2021-10-15
  onSuccess = async () => {
    try {
      await axios.get(`${CONFIG.apiURL}${this.props.ws_sukces}`)

      if (this.props.pay_web === '4') {
        if (this.props.onPrzelewy24Success)
          await this.props.onPrzelewy24Success()
      }
    } catch (error) {
      console.log(error)
    }
  }

  //PM 2021-10-15
  onFailure = async () => {
    try {
      await axios.get(`${CONFIG.apiURL}${this.props.ws_porazka}`)

      if (this.props.pay_web === '4') {
        if (this.props.onPrzelewy24Failure)
          await this.props.onPrzelewy24Failure()
      }
    } catch (error) {
      console.log(error)
    }
  }

  //PM 2021-10-18
  //test platnosci wg propsow
  render() {

    if (this.state.openInfo)
      return (
        <Dialog
          disableEscapeKeyDown
          maxWidth="xs"
          open={this.props.open}
        >
          <DialogContent>
            <DialogContentText>{`Teraz wykonywana jest testowa płatność internetowa ${this.getPlatnosc()}`}</DialogContentText>
            <DialogContentText>{`kwota: ${this.props.kwota}`}</DialogContentText>
            <DialogContentText>{`vsc_ident: ${this.props.vsc_ident}`}</DialogContentText>
            <DialogContentText>{`ws_sukces: ${CONFIG.apiURL}${this.props.ws_sukces}`}</DialogContentText>
            <DialogContentText>{`ws_porazka: ${CONFIG.apiURL}${this.props.ws_porazka}`}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" size="small" onClick={() => this.setState({ ...this.state, openInfo: false, openTakNie: true })} style={{ color: '#458B00' }}>
              <b>OK</b>
            </Button>
          </DialogActions>
        </Dialog>
      );
    else if (this.state.openTakNie)
      return (
        <Dialog
          disableEscapeKeyDown
          maxWidth="xs"
          open={this.props.open}
        >
          <DialogContent>
            <DialogContentText>{`Wybierz "tak", aby zakończyć transakcję sukcesem`}</DialogContentText>
            <DialogContentText>{`Wybierz "nie", aby zakończyć transakcję porażką`}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" size="small" onClick={this.onFailure} style={{ color: '#3a87ad' }}>
              <b>nie</b>
            </Button>
            <Button variant="outlined" size="small" onClick={this.onSuccess} style={{ color: '#458B00' }}>
              <b>tak</b>
            </Button>
          </DialogActions>
        </Dialog>
      );
  }
}

export default Notifier;